import { useState, useEffect } from "react";
import api from "../../api/api";
import SideNavLayout from "../../customsidenav/sidenavlayout";
import ReactPaginate from "react-paginate";
import { CircularProgress } from "@mui/material";
import { FaChevronLeft, FaChevronRight, FaPencilAlt, FaTimes, FaTrash } from "react-icons/fa";
import './rpm.css';
import UnassignDeviceModal from "../modals/assign";
import DeleteDeviceModal from "../modals/deletedevicemodal";
import EditDevicesModal from "../modals/editdevices";
import AddDevicesModal from "../modals/adddevices";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { getPracticeId } from "../../config/practice";

const RpmDevices = () => {
  const [devices, setDevices] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
const [statusSort, setStatusSort] = useState("assigned"); 
// "assigned" | "active"

// null | "asc" | "desc"

  const [toastSeverity, setToastSeverity] = useState('success');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [apiLoading,setApiLoading]=useState(false)
  const [isaddDeviceModal,setAddDeviceModal]=useState(false)
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
const [unassignmodal,setUnassignModal]=useState(false)
const [deletemodal,setDeleteModal]=useState(false)
const [isEditmodal,setIsEditModal]=useState(false)
const[selectedcolumn,setSelectedColumn]=useState({});
const practiseid = getPracticeId();
const toggleStatusSort = () => {
  setCurrentPage(0);

  setStatusSort(prev =>
    prev === "assigned" ? "active" : "assigned"
  );
};


const handleToastClose = () => {
  setOpenToast(false);
};
const navigate=useNavigate()
  // Fetching data from the API
  const fetchdata = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/v1/${practiseid}/rpm_devices/get_devices`);
      setDevices(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  // Reset current page when search query changes
  useEffect(() => {
    setCurrentPage(0);
    
  }, [searchQuery]);

  // Handle page click
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
const unassigncolumn=async()=>{

  try {
    setApiLoading(true)
    const response=await api.put(`v1/${practiseid}/patient/${selectedcolumn.patientid}/rpm/device-unassign`,{
      "devicesno": selectedcolumn.deviceserialnumber,
      "devicetype": selectedcolumn.devicetype,
      "created_by": selectedcolumn.created_by,
    })
    if(response.status==200){
        setToastMessage(response.message);
  setToastSeverity('success');
  setOpenToast(true);
    setUnassignModal(false)
    fetchdata()
    }else{ 
       setToastMessage(response.message);
      setToastSeverity('info');
      setOpenToast(true);
    }
  } catch (error) {
    console.log(error)
  }finally{
setApiLoading(false)
  }
}

const deletecolumn=async()=>{
  try {
    setApiLoading(true)
    const response=await api.delete(`/v1/${practiseid}/rpm_devices/delete_device/${selectedcolumn.id}`)
    if(response.status==200){
      setToastMessage(response.message);
      setToastSeverity('success');
      setOpenToast(true);
      setDeleteModal(false)
      fetchdata()
    }else{
      setToastMessage(response.message);
      setToastSeverity('info');
      setOpenToast(true);
    }
  } catch (error) {
    console.log(error)
    setToastMessage(error?.response?.data?.message || "Failed to delete the device");
    setToastSeverity('error');
    setOpenToast(true);
  }finally{
    setApiLoading(false)
  }
}




let filteredDevices = devices.filter((device) => {
  return (
    device.deviceserialnumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
    device.devicedetails.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (device.patientid && String(device.patientid).includes(searchQuery))
  );
});

filteredDevices = [...filteredDevices].sort((a, b) => {
  const aAssigned = a.rpm?.length > 0;
  const bAssigned = b.rpm?.length > 0;

  if (statusSort === "assigned") {
    return bAssigned - aAssigned; // assigned first
  } else {
    return aAssigned - bAssigned; // active first
  }
});

  // Slice the data to show only the current page's devices
  const currentDevices = filteredDevices.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  // Calculate dynamic range of entries displayed
  const startIndex = currentPage * itemsPerPage + 1;
  const endIndex = Math.min((currentPage + 1) * itemsPerPage, filteredDevices.length);

  return (<>
    <div className="h-full">
      <SideNavLayout>
        <div className="flex justify-between items-center mb-4">
          <div className="text-lg font-semibold">Devices</div>
          <div>
            <button className="btn  mr-2 "
            onClick={()=>navigate(-1)}
            > <ArrowBackIosNewIcon style={{width:'12px',marginBottom:'4px',marginRight:'5px'}} /> Back</button>
            <button className="bg-[#E17954] px-3 rounded pt-1 text-sm text-white"
            onClick={()=>setAddDeviceModal(true)}
            > <AddIcon style={{width:'16px',marginBottom:'4px',marginRight:'5px'}} />Add New Device</button>
          </div>
        </div>

        {/* White card container */}
        <div className="bg-white p-6 rounded-lg shadow-md mb-4 min-h-[60vh]  ">
          <div className="flex justify-between items-center mb-4">
            {/* Left side: Dropdown for number of entries */}
            <div className="text-sm flex items-center gap-2">
              Show
              <select
                className="ml-2 border p-1 rounded-md text-sm"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
              </select>
              entries
            </div>

            {/* Right side: Search text and search bar */}
            <div className="flex items-center">
              <span className="mr-2 text-sm">Search :</span>
              <input
                type="text"
                placeholder="Search by ID or Device No..."
                className="border p-1 rounded-md text-sm"
                value={searchQuery} // Controlled input
                onChange={(e) => {
                  setSearchQuery(e.target.value); // Update query
                  setCurrentPage(0); // Reset to the first page
                }}
              />
            </div>
          </div>

          {/* Loader for fetching data */}
          {loading ? (
            <div className="flex justify-center py-4">
              <CircularProgress />
            </div>
          ) : (
            <>
              {/* Table */}
              <table className="min-w-full table-auto">
                <thead>
                  <tr className="border-b text-[#E17954] text-sm font-semibold">
                    <th className="px-4 py-2 text-left ">SN</th>
                    <th className="px-4 py-2 text-left">Device No</th>
                    <th className="px-4 py-2 text-left">Device Type</th>
                    <th className="px-4 py-2 text-left">Device Details</th>
                    <th className="px-4 py-2 text-left">Patient ID</th>
             <th className="px-4 py-2 text-left cursor-pointer">
  <div className="flex items-center gap-1" onClick={toggleStatusSort}>
    Status
    <SwapVertIcon style={{ fontSize: 16 }} />
  </div>
</th>


                    <th className="px-4 py-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentDevices.map((device, index) => (
                    <tr className="border-b" key={startIndex + index}>
                      <td className="px-4 py-2 text-left font-semibold text-[12px]">{startIndex + index}</td>
                      <td className="px-4 py-2 text-left text-[#4B5563] font-semibold text-[12px]">{device.deviceserialnumber}</td>
                      <td className="px-4 py-2 text-left text-[#4B5563] font-semibold text-[12px]">{device.devicetype}</td>
                      <td className="px-4 py-2 text-left text-[#4B5563] font-semibold text-[12px]">{device.devicedetails}</td>
                      <td className="px-4 py-2 text-left text-[#4B5563] font-semibold text-[12px]">{device.patientid}</td>
                     <td className="px-4 py-1 text-center">
  {device.rpm?.length > 0 ? (
    <div className="bg-[#FFF5F5] text-[#E17954] px-2 py-1 rounded-md font-semibold text-[12px]">
      Assigned
    </div>
  ) : (
    <div className="bg-[#ECFDF5] text-[#059669] px-2 py-1 rounded-md font-semibold text-[12px]">
      Active
    </div>
  )}
</td>
                      <td className="px-4 py-2 text-left">
                        <div className="flex items-center">

                             <button onClick={()=>{
                            setSelectedColumn(device)
                          setIsEditModal(true)
                        }} className="btn">
                          <FaPencilAlt />
                        </button>
                        <button onClick={()=>{
                          setSelectedColumn(device)
                          setUnassignModal(true)
                        }} className="btn  ml-2" title="Unassign device">
                          <FaTimes style={{color:'red'}} />
                        </button>
                        <button onClick={()=>{
                          setSelectedColumn(device)
                          setDeleteModal(true)
                        }} className="btn  ml-2" title="Delete device">
                          <FaTrash style={{color:'red'}} />
                        </button>
                        </div>
                     
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              <div className="mt-4 flex justify-between">
                {/* Displaying dynamic range of entries */}
                <span className="text-sm text-[#6B7280] text-[14px]">
                  Showing {startIndex} to {endIndex} of {filteredDevices.length} entries
                </span>
                <ReactPaginate
  previousLabel={<div className="px-2 py-[6.3px] border-[1.2px] text-sm border-[#ccc] mr-1 rounded text-[#ccc] hover:bg-orange-500 hover:text-white">Previous</div>}
  nextLabel={<div className="px-2 py-[6.3px] border-[1.2px] text-sm border-[#ccc] ml-1 rounded text-[#ccc] hover:bg-orange-500 hover:text-white">Next</div>}
  pageCount={Math.ceil(filteredDevices.length / itemsPerPage)}
  onPageChange={handlePageClick}
  containerClassName={"pagination"}
  activeClassName={"active orange-active"} // Apply 'orange-active' for active state
  pageClassName={"page-item"}
  pageLinkClassName={
    "page-link px-3 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-orange-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
  }
  previousClassName={"previous"}
  nextClassName={"next"}
  forcePage={currentPage}
/>
<style>{`
        .pagination a {
          text-decoration: none;
        }
        .pagination .active a {
          text-decoration: none;
        }
        .pagination .page-link {
          text-decoration: none;
        }

      `}</style>
              </div>
            </>
          )} 
        </div>
      </SideNavLayout>
    </div>
    <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    <UnassignDeviceModal unassigncolumn={unassigncolumn} apiLoading={apiLoading} isOpen={unassignmodal} onClose={setUnassignModal}/>
    <DeleteDeviceModal deletecolumn={deletecolumn} apiLoading={apiLoading} selectedcolumn={selectedcolumn} isOpen={deletemodal} onClose={setDeleteModal}/>
    <EditDevicesModal
     fetchdata={fetchdata}
     setToastMessage={setToastMessage}
     setOpenToast={setOpenToast}
     setToastSeverity={setToastSeverity}
    selectedcolumn={selectedcolumn} apiLoading={apiLoading} isOpen={isEditmodal} onClose={setIsEditModal} />
    <AddDevicesModal
    fetchdata={fetchdata}
    setToastMessage={setToastMessage}
    setOpenToast={setOpenToast}
    setToastSeverity={setToastSeverity}
    apiLoading={apiLoading} isOpen={isaddDeviceModal} onClose={setAddDeviceModal}/>
  </> 
  );
};

export default RpmDevices;
